import React, { useEffect } from 'react';
import Toast from './Toast';
import { useToast } from '../../context/ToastContext';

const ToastContainer = () => {
  const { toasts, removeToast, clearAllToasts } = useToast();

  // 客戶補充：多則提醒一起跳出時來不及看完。
  // 既然全改為手動關閉，提供 ESC 一鍵關閉最新一則、Shift+ESC 一次清空整個堆疊，
  // 並在堆疊 ≥2 時保留「全部關閉」按鈕給滑鼠使用者。
  useEffect(() => {
    if (toasts.length === 0) return undefined;
    const handleKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      if (event.shiftKey) {
        clearAllToasts();
        return;
      }
      const latest = toasts[toasts.length - 1];
      if (latest) removeToast(latest.id);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toasts, removeToast, clearAllToasts]);

  return (
    <div
      className="toast-container"
      role="region"
      aria-live="polite"
      aria-label="系統提醒區"
    >
      {toasts.length >= 2 && (
        <button
          type="button"
          className="toast-clear-all"
          onClick={clearAllToasts}
          aria-label={`一次關閉全部 ${toasts.length} 則提醒`}
          title="全部關閉（Shift + Esc）"
        >
          全部關閉（{toasts.length}）
        </button>
      )}
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
